import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translations
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enSpaces from './locales/en/spaces.json';
import enContact from './locales/en/contact.json';
import enFloors from './locales/en/floors.json';
import enHero from './locales/en/hero.json';
import enTour from './locales/en/tour.json';

import esCommon from './locales/es/common.json';
import esNavigation from './locales/es/navigation.json';
import esSpaces from './locales/es/spaces.json';
import esContact from './locales/es/contact.json';
import esFloors from './locales/es/floors.json';
import esHero from './locales/es/hero.json';
import esTour from './locales/es/tour.json';

import zhCommon from './locales/zh/common.json';
import zhNavigation from './locales/zh/navigation.json';
import zhSpaces from './locales/zh/spaces.json';
import zhContact from './locales/zh/contact.json';
import zhFloors from './locales/zh/floors.json';
import zhHero from './locales/zh/hero.json';
import zhTour from './locales/zh/tour.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    spaces: enSpaces,
    contact: enContact,
    floors: enFloors,
    hero: enHero,
    tour: enTour,
  },
  es: {
    common: esCommon,
    navigation: esNavigation,
    spaces: esSpaces,
    contact: esContact,
    floors: esFloors,
    hero: esHero,
    tour: esTour,
  },
  zh: {
    common: zhCommon,
    navigation: zhNavigation,
    spaces: zhSpaces,
    contact: zhContact,
    floors: zhFloors,
    hero: zhHero,
    tour: zhTour,
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
    },
    
    react: {
      useSuspense: false,
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
